import React from 'react';

const LogInImage = () => {
	return <div className='logInContainer'></div>;
};

export default LogInImage;
